import axios from "axios";

import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";
const deleteWarnDoc = "/api/telcoServices/deleteWarnDoc";
const baseApiFile = "/api/revenue/telcoServices/file?file_id=";

export default class AccountKSService {
  private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;
  public getAllCompanies(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/company?page=0&size=10000", querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getAllCompaniesV2(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/companyV2", querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public SearchDebtCCDV(querySearch: any, cancelToken): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/ccdv-fee-management/finan-debt", querySearch, {
          cancelToken: cancelToken.token,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public excelCCDV(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/ccdv-fee-management/finan-debt/excel", querySearch, { responseType: "blob" })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(reject(err));
        });
    });
  }
  public getNetwork(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/cert/network-type")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
